import { Table } from '../components'
import { useQuery } from "react-query";
import { HistoryApi } from "../api";
import { InnerPageSection, InnerPageTitle } from "../components";
import { Text } from '@eo-locale/react';

export const PermissionsPage = () => {
    const { data } = useQuery('user-history', HistoryApi.fetch);
    return (
        <InnerPageSection>
            <InnerPageTitle>
                <Text id="permissions:title" />
            </InnerPageTitle>
            <Table>
                <thead>
                    <tr>
                        <th>
                            <Text id="permissions:name" />
                        </th>
                        <th>
                            <Text id="permissions:date" />
                        </th>
                        <th>
                            <Text id="permissions:id" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {data?.permissions.data.map((permission, index) => (
                        <tr key={index}>
                            <td>{permission.name}</td>
                            <td>{permission.date}</td>
                            <td>{permission.identification_number}</td>
                        </tr>
                    ))}
                    {data?.globalPermissions.data.map((permission, index) => (
                        <tr key={index}>
                            <td>{permission.name}</td>
                            <td>{'-'}</td>
                            <td>{permission.identification_number}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </InnerPageSection>
    )
}
